<div *ngIf="normalizedSources.length" class="sources">
  <tabset *ngIf="normalizedSources.length > 1">
    <tab
      *ngFor="let tab of normalizedSources; let index = index"
      heading="{{ normalizedSources[index].name }}"
      [active]="normalizedSources[index].active"
    >
      <pre class="prettyprint">{{ normalizedSources[index].text }}</pre>
    </tab>
  </tabset>
  <pre *ngIf="normalizedSources.length === 1" class="prettyprint">{{
    normalizedSources[0].text
  }}</pre>
</div>
